import React, { useEffect } from "react";
import { motion } from "framer-motion";
import bgImg from '../Images/contact-us.webp'
import Breadcrumb from "../Components/Breadcrumb";

const TermsConditions=()=>{
    useEffect(() => {
                document.title =
                  "Terms & Conditions | Dr. Jigar Gor Ayurvedic Clinic";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Read the terms and conditions for Dr. Jigar Gor’s clinic website. Read about appointment scheduling, cancellations, and treatment guidelines."
                  );
                }
            
               const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://msayurved.com/terms-and-conditions");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Terms & Conditions | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Read the terms and conditions for Dr. Jigar Gor’s clinic website. Read about appointment scheduling, cancellations, and treatment guidelines."
                );
              }
            
             const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://msayurved.com/terms-and-conditions");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/home.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Terms & Conditions | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Read the terms and conditions for Dr. Jigar Gor’s clinic website. Read about appointment scheduling, cancellations, and treatment guidelines."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/home.webp"
                );
              }
              }, []);
    const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  // PREMIUM FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 38,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };            
    return(
        <>
           {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Terms & Conditions"
        bgImage={bgImg}
        />

        {/**TERMS & CONDITIONS */}
    <motion.section
        className="privacy-section container"
         variants={containerVariants}
         initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.04,
        }}
      >

         <motion.p
            className="section-subheading"
            variants={fadeUp}
        >Guidelines for Using Our Website & Services</motion.p>
        
        <motion.h2
        className="section-heading"
        variants={fadeUp}
        >
        Please Read These Terms Before Using Our Website or Services
        </motion.h2>

        {/* 1 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          1. Definitions
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            In this Contract the following listed words shall
            have the following meanings:
          </li>

        </motion.ul>

        <motion.div
          className="privacy-sub-list"
          variants={fadeUp}
        >

          <p className="section-text">
            <strong>“Customer”</strong> : Any legal entity or
            natural person purchasing services from Dr. Jigar Gor's Ayurvedic Clinic for professional or personal
            property settlement purposes.
          </p>

          <p className="section-text">
            <strong>“Services”</strong> : All Ayurvedic consultations, treatments, wellness programs, health assessments, therapies, educational resources, and related healthcare services provided by Dr. Jigar Gor's Ayurveda Clinic.
          </p>

          <p className="section-text">
            <strong>“Company”</strong> : Dr. Jigar Gor's Ayurvedic Clinic
          </p>

          <p className="section-text">
            <strong>“We”, “Our”, “Us”</strong> : Shall mean
            Dr. Jigar Gor's Ayurvedic Clinic.
          </p>

          <p className="section-text">
            <strong>“Website”</strong> : The website
            <a
              href="https://msayurved.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-main"
            >
              {" "}
              msayurved.com
            </a>
          </p>

          <p className="section-text">
            <strong>“Seller”</strong> : Dr. Jigar Gor's Ayurveda Clinic, providing Ayurvedic consultations, treatments, therapies, wellness programs, and related healthcare services.
          </p>

          <p className="section-text">
            <strong>“Terms of Use”</strong> : These Terms &
            Conditions including any future amendments.
          </p>

          <p className="section-text">
            <strong>“Party”</strong> : The Customer and Dr. Jigar Gor's Ayurvedic Clinic collectively referred to as
            the “Parties”.
          </p>

          <p className="section-text">
            <strong>“You”</strong> : Any natural or legal
            person browsing, accessing, or using the Website
            or Services.
          </p>

          <p className="section-text">
            <strong>“Contract”</strong> : Any agreement,
            instruction, quote acceptance, or transaction
            entered into between the Customer and Dr. Jigar Gor's Ayurvedic Clinic
          </p>

        </motion.div>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          In this Contract, clause headings are included for
          convenience only and shall not affect interpretation.
        </motion.p>

        {/* 2 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          2. Interpretation
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          These Terms & Conditions apply to all services
          provided by Dr. Jigar Gor's Ayurvedic Clinic unless otherwise
          agreed in writing. If any conflict arises between
          additional agreements and these Terms, the additional
          written agreement shall prevail.
        </motion.p>

        {/* 3 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          3. Service Requests & Instructions
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Requests for services may be submitted
            via phone, email, online enquiry forms, or direct
            consultation.
          </li>

          <li className="section-text">
           Dr. Jigar Gor's Ayurveda Clinic may request personal identification, medical history, health records, consent forms, and other relevant information necessary to provide consultations, treatments, and healthcare services.
          </li>

          <li className="section-text">
            Clients are responsible for ensuring all
            information provided is accurate, complete, and up
            to date.
          </li>

        </motion.ul>

        {/* 4 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          4. Service Availability
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            All services are subject to legal requirements,
            authority approvals, document availability, and
            settlement timelines.
          </li>

          <li className="section-text">
            Dr. Jigar Gor's Ayurvedic Clinic reserves the right to
            refuse or delay services where insufficient
            documentation or compliance issues exist.
          </li>

        </motion.ul>

        {/* 5 */}

         <motion.h3
                  className="card-heading"
                  variants={fadeUp}
                >
          5. Fees & Payments
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Quotes provided are estimates based on the
            information available at the time.
          </li>

          <li className="section-text">
            Additional fees, government charges, or third-party
            costs may apply depending on the transaction.
          </li>

          <li className="section-text">
            Payment terms for consultations, treatments, therapies, and other services will be communicated in advance and must be paid within the agreed timeframe.
          </li>

        </motion.ul>

        {/* 6 */}

         <motion.h3
                  className="card-heading"
                  variants={fadeUp}
                >
          6. Liability
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
           Dr. Jigar Gor's Ayurvedic Clinic shall not be liable for
            delays caused by financial institutions, government
            authorities, third parties, system outages, or
            circumstances beyond reasonable control.
          </li>

          <li className="section-text">
            We are not responsible for losses resulting from
            inaccurate information or documents supplied by the
            client or third parties.
          </li>

          <li className="section-text">
            Our liability is limited to the extent permitted
            under Australian law.
          </li>

        </motion.ul>

        {/* 7 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          7. Website Usage
        </motion.h3>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Content on this website is provided for general
            informational purposes only.
          </li>

          <li className="section-text">
            Users may not copy, reproduce, or distribute any
            website content without prior written permission.
          </li>

          <li className="section-text">
            External links provided on this website are for
            convenience only and Dr. Jigar Gor's Ayurvedic Clinic is not
            responsible for third-party content.
          </li>

        </motion.ul>

        {/* 8 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          8. Privacy
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Your personal information is handled in accordance
          with our Privacy Policy and applicable Australian
          privacy laws.
        </motion.p>

        {/* 9 */}

        <motion.h3
                 className="card-heading"
                 variants={fadeUp}
               >
          9. Amendments
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Dr. Jigar Gor's Ayurvedic Clinic reserves the right to update
          or modify these Terms & Conditions at any time
          without prior notice.
        </motion.p>

        {/* 10 */}

         <motion.h3
                  className="card-heading"
                  variants={fadeUp}
                >
          10. Contact Information
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          For any questions regarding these Terms &
          Conditions, please contact us at
          <a
            href="mailto:dr.jigargor@yahoo.com"
            className="text-main"
          >
            {" "}
            dr.jigargor@yahoo.com
          </a>
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
           © 2026 – Dr Jigar Gor's Ayurveda Clinic
        </motion.p>

      </motion.section>
        </>
    )
}
export default TermsConditions;